import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (body) => ({
        url: "user/login",
        method: "POST",
        body,
      }),
    }),
    logoutUser: builder.mutation({
      query: () => ({
        url: "user/logout",
        method: "GET",
      }),
    }),
    reloadAccess: builder.mutation({
      query: () => "user/reload-access",
    }),
    resetPassword: builder.mutation({
      query: ({ body, reCaptcha, email }) => ({
        url: `user/resetpassword`,
        method: "POST",
        body: { ...body, reCaptcha, email },
      }),
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: "user/changepassword",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useLogoutUserMutation,
  useReloadAccessMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
} = authApiSlice;
